import api from 'src/api/index';
import i18n from 'src/i18n';
import { setConsultationsLoading } from 'src/store/consultations';
import { setCourseLoading } from 'src/store/courses';
import { setLectureLoading } from 'src/store/lectures';
import store from 'src/store/store';
import { showErrorToast } from 'src/store/toast';
import { setWebinarsLoading, webinarsErrorMessage } from 'src/store/webinars';
import Uploader from './Uploader';
import { setMeditationLoading } from 'src/store/meditations';
import { setMarathonLoading } from 'src/store/marathons';

class ContentCreater {
	constructor(type) {
		this.type = type;
	}

	createContent( payload ) {

		if (this.type === 'lecture') {

			return this.#createLecture( payload );

		} else if (this.type === 'webinar') {

			return this.#createWebinar( payload );

		} else if (this.type === 'meditation') {

			return this.#createMeditaion( payload );

		} else if (this.type === 'consultation') {

			return this.#createConsultation( payload );

		} else if (this.type === 'marathon') {

			return this.#createMarathon(payload);

		}
		
		 else {

			return this.#createCourse( payload );

		}

	}

	async #createLecture(lecture) {

		store.dispatch( setLectureLoading(true) );

		try {

			// Загружаем обложку только если нет imageId
			if ( lecture.cover && !lecture.imageId ) {

				const imageId = await Uploader.uploadImage(lecture.cover);
				delete lecture.cover;
				lecture.imageId = imageId;

			} else if ( lecture.cover ) {
				// Если imageId уже есть, просто удаляем cover
				delete lecture.cover;
			}

			const res = await api.createLecture(lecture);
			return res;

		} catch (error) {

			console.error(error);
			if (!error?.toastShown) {
				store.dispatch(
					showErrorToast({
						description: i18n.t('toasts.failedCreateLecture'),
					})
				);
			}

			throw error;

		} finally {

			store.dispatch(setLectureLoading(false));

		}

	}

	async #createMeditaion(meditation) {

		store.dispatch( setMeditationLoading(true) );

		try {

			// Загружаем обложку только если нет imageId
			if ( meditation.cover && !meditation.imageId ) {

				const imageId = await Uploader.uploadImage(meditation.cover);
				delete meditation.cover;
				meditation.imageId = imageId;

			} else if ( meditation.cover ) {
				// Если imageId уже есть, просто удаляем cover
				delete meditation.cover;
			}

			const res = await api.createMeditation(meditation);
			return res;

		} catch (error) {

			console.error(error);
			if (!error?.toastShown) {
				store.dispatch(
					showErrorToast({
						description: i18n.t('toasts.failedCreateMeditation'),
					})
				);
			}

			throw error;

		} finally {

			store.dispatch(setMeditationLoading(false));

		}

	}

	async #createCourse(course) {

		store.dispatch( setCourseLoading(true) );

		try {

			// Загружаем обложку только если нет imageId
			if ( course.cover && !course.imageId ) {

				const imageId = await Uploader.uploadImage(course.cover);
				delete course.cover;
				course.imageId = imageId;

			} else if ( course.cover ) {
				// Если imageId уже есть, просто удаляем cover
				delete course.cover;
			}

			console.log('ContentCreater отправляет курс:', course);
			const response = await api.createCourse(course);
			console.log('ContentCreater получил ответ:', response);
			return response;

		} catch (error) {

			console.log(error);
			if (!error?.toastShown) {
				store.dispatch(
					showErrorToast({
						description: i18n.t('toasts.failedCreateCourse'),
					})
				);
			}

			throw error;

		} finally {
			store.dispatch( setCourseLoading(false) );
		}
	}

	async #createMarathon(marathon) {

		store.dispatch( setMarathonLoading(true) );

		try {

			// Загружаем обложку только если нет imageId
			if ( marathon.cover && !marathon.imageId ) {

				const imageId = await Uploader.uploadImage(marathon.cover);
				delete marathon.cover;
				marathon.imageId = imageId;

			} else if ( marathon.cover ) {
				// Если imageId уже есть, просто удаляем cover
				delete marathon.cover;
			}

			const response = await api.createMarathon(marathon);
			return response;

		} catch (error) {

			console.log(error);
			if (!error?.toastShown) {
				store.dispatch(
					showErrorToast({
						description: i18n.t('toasts.failedCreateMarathon'),
					})
				);
			}

			throw error;

		} finally {
			store.dispatch( setMarathonLoading(false) );
		}

	}

	async #createWebinar(webinar) {

		store.dispatch( setWebinarsLoading(true) );

		try {

			// Загружаем обложку только если нет imageId
			if ( webinar.cover && !webinar.imageId ) {

				const imageId = await Uploader.uploadImage(webinar.cover);
				delete webinar.cover;
				webinar.imageId = imageId;

			} else if ( webinar.cover ) {
				// Если imageId уже есть, просто удаляем cover
				delete webinar.cover;
			}

			const response = await api.createWebinar(webinar);
			return response;

		} catch (error) {

			console.error(error?.response?.data);

			const errorText = webinarsErrorMessage(error?.response?.data);

			store.dispatch(
				showErrorToast({
					description: errorText,
				})
			);

			throw error;
			
		} finally {
			store.dispatch( setWebinarsLoading(false) );
		}
	}

	async #createConsultation(consultation) {

		store.dispatch( setConsultationsLoading(true) );
		
		try {

			// Загружаем обложку только если нет imageId
			if ( consultation.cover && !consultation.imageId ) {

				const imageId = await Uploader.uploadImage(consultation.cover);
				delete consultation.cover;
				consultation.imageId = imageId;

			} else if ( consultation.cover ) {
				// Если imageId уже есть, просто удаляем cover
				delete consultation.cover;
			}

			const response = await api.createConsultation(consultation);
			return response;

		} catch (error) {

			console.log(error);

			if (!error?.toastShown) {
				store.dispatch(
					showErrorToast({
						description: i18n.t('toasts.failedCreateConsultation'),
					})
				);
			}

			throw error;

		} finally {
			store.dispatch( setConsultationsLoading( false ));
		}
	}
		
}

export default ContentCreater;
